import React from 'react'
import { InsuredAmount } from './InsuredAmount'
import { Stack } from 'react-bootstrap'
import { AdvanceShippingOption } from './AdvanceShippingOption'
import { PoNumber } from './PoNumber'

export const PurchaseOption = () => {
  return (
    <Stack gap={2}>
      <div>
        <PoNumber />
      </div>
      <div>
        <InsuredAmount />
      </div>
      <div>
        <AdvanceShippingOption />
      </div>
    </Stack>
  )
}
